import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const el = document.querySelector(a.getAttribute("href"));
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -72 });
            }
        };
        document.addEventListener("click", onClick);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            document.removeEventListener("click", onClick);
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors theme="dark" />
        </div>
    );
}

export default App;
